/**
 * Seção "Comportamento padrão" em modo edição (Brief 4 · Tela 2 · PR5).
 *
 * `sideDefault` (ADR-041) + `adversarialProfileDefault` (ADR-040) como SELECTS dos
 * valores canônicos do enum (Prisma/serializer — conjunto fechado real, ao contrário
 * do `voiceProfile`). Cada select mostra a descrição honesta do valor selecionado;
 * `strict` revela a nota de bloqueio do modo H_c (espelha a leitura). R15: enums
 * escalares persistem direto via PATCH (version++).
 */

import {
  ADVERSARIAL_LABELS,
  SIDE_LABELS,
  adversarialDescription,
  sideDescription,
} from '../persona-labels';

import type { PersonaAdversarial, PersonaSide } from '../types';
import type { PersonaForm } from '../use-persona-form';

const SIDE_ORDER: PersonaSide[] = ['seller', 'buyer', 'neutral', 'mediator'];
const ADVERSARIAL_ORDER: PersonaAdversarial[] = ['none', 'competitive', 'partial', 'strict'];

export function SectionBehaviorEdit({ form }: { form: PersonaForm }): JSX.Element {
  const { sideDefault, adversarialProfileDefault } = form.draft;
  const sideDesc = sideDescription(sideDefault);
  const advDesc = adversarialDescription(adversarialProfileDefault);

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Comportamento padrão</h2>
      <p className="pe-panel__subtitle">Lado representado e perfil adversarial.</p>
      <div className="pe-grid-2">
        <div className="pe-field">
          <label className="pe-field__label" htmlFor="pe-side">
            Lado padrão
          </label>
          <select
            id="pe-side"
            className="pe-select"
            value={sideDefault}
            onChange={(e) => {
              form.set('sideDefault', e.target.value as PersonaSide);
            }}
          >
            {SIDE_ORDER.map((s) => (
              <option key={s} value={s}>
                {SIDE_LABELS[s]}
              </option>
            ))}
          </select>
          {sideDesc !== '' && <p className="pe-read-value pe-read-value--muted">{sideDesc}</p>}
        </div>
        <div className="pe-field">
          <label className="pe-field__label" htmlFor="pe-adversarial">
            Perfil adversarial
          </label>
          <select
            id="pe-adversarial"
            className="pe-select"
            value={adversarialProfileDefault}
            onChange={(e) => {
              form.set('adversarialProfileDefault', e.target.value as PersonaAdversarial);
            }}
          >
            {ADVERSARIAL_ORDER.map((a) => (
              <option key={a} value={a}>
                {ADVERSARIAL_LABELS[a]}
              </option>
            ))}
          </select>
          {advDesc !== '' && <p className="pe-read-value pe-read-value--muted">{advDesc}</p>}
        </div>
      </div>
      {adversarialProfileDefault === 'strict' && (
        <p className="pe-note pe-note--warning" role="note">
          Modo H_c bloqueado em conversas desta persona — perfil adversarial estrito, disponível
          apenas no pacote Regulated.
        </p>
      )}
    </section>
  );
}
